<div class="data-table-column {{additionalClass}}" *ngIf="template">
    <ng-container *ngTemplateOutlet="template; context: item"></ng-container>
</div>